/* eslint-disable @typescript-eslint/no-explicit-any */
import { AndroidInterface } from "@/apps/credit-line/services/android.service";

declare const Android: AndroidInterface;

/**
 * Safely call a method on the Android interface if it exists.
 * This prevents errors in non-Android environments.
 * @param methodName The name of the method to call on the Android interface
 * @param args Arguments to pass to the method
 * @returns The result of the method call, or undefined if not available
 */
export const safeAndroidCall = (
  methodName: keyof AndroidInterface,
  ...args: any[]
): unknown => {
  if (typeof Android !== "undefined" && Android[methodName]) {
    return (Android[methodName] as (...args: any[]) => unknown)(...args);
  }
};
